<template><div>
  <!-- プロジェクト管理画面 -->
  <CCard>
    <CCardHeader>
      <h2>
        <span>プロジェクト管理</span>
        <span class="card-header-actions">
          <router-link :to="{ name: projectRegister }">
            <button class="btn btn-primary">新規登録</button>
          </router-link>
        </span>
      </h2>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="errors.length">
        <ul>
          <li style="color: red" v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </CRow>
      <!-- ▼ 所属プロジェクト（カード表示） -->
      <div v-if="myProjects.length" class="mb-3">
        <h5 class="mb-2">所属プロジェクト</h5>
        <CRow class="mb-3">
          <CCol v-for="p in myProjects" :key="p.id" sm="12" md="6" lg="4" xl="3">
            <CCard color="info" class="text-white card-select" @click="goProject(p.id)">
              <CCardBody class="py-3">
                <div class="font-weight-bold">{{ p.name }}</div>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div>
      <!-- ▲ 所属プロジェクト（カード表示） -->
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="text-center">除外/追加</th>
              <th scope="col">プロジェクト名</th>
              <th scope="col">顧客会社名</th>
              <th scope="col">顧客会社担当者</th>
              <th scope="col">自社管理者</th>
              <th scope="col">契約形態</th>
              <th scope="col">基準時間</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in project" :key="item.id">
              <td class="text-center">
                <label class="custom-switch">
                  <input
                    type="checkbox"
                    class="custom-switch-input"
                    :id="`prj${item.id}`"
                    :checked="item.checked"
                    @change="onToggle(item, $event.target.checked)"
                  />
                  <span class="custom-switch-indicator"></span>
                </label>
              </td>
              <td>
                <router-link
                  :to="{ name: projectInfo, params: { value: item } }"
                  >{{ item.name }}</router-link
                >
              </td>
              <td>{{ item.company_name }}</td>
              <td>{{ item.staff_name }}</td>
              <td>{{ item.private_staff_name }}</td>
              <td>{{ item.contract }}</td>
              <td>{{ item.base_time }}</td>
              <td>
                <button
                  v-on:click="openModal(item, index)"
                  class="btn btn-danger"
                >
                  削除
                </button>
                <!-- 削除モーダルコンポーネント呼出 -->
                <ProjectDeleteModal
                  :draggable="true"
                  :resizable="true"
                  :val="postItem"
                  :loading="loading"
                  v-show="showModal"
                  @delete="deleteProject"
                  @close="closeModal"
                >
                </ProjectDeleteModal>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <!-- ページング処理 -->
        <VPagination
          v-model="currentPage"
          :click-handler="changePage"
          :page-count="totalPages"
          :force-ellipses="true"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :prev-text="'<'"
          :next-text="'>'"
          :prev-link-class="'page-link'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :class-prefix="'pagination'"
        />
      </div>
    </CCardBody>
  </CCard>
  <div v-if="globalLoading" class="loading-overlay" aria-live="polite" aria-busy="true">
    <CSpinner color="primary" style="width: 3rem; height: 3rem;" />
  </div>
</div></template>

<script>
import axios from "axios";
import ConstList from "./../ConstList";
import ProjectDeleteModal from "./ProjectDeleteModal";
import VPagination from "vuejs-paginate";
export default {
  name: "ProjectList",
  components: {
    ProjectDeleteModal,
    VPagination,
  },
  data() {
    return {
      globalLoading: false,
      showModal: false,
      errors: [],
      project: [],
      company: [],
      user: [],
      postItem: "",
      project_id: "",
      deleted_flg: "",
      selectedPrjIds: [],
      projectRegister: "",
      projectInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      myProjects: [],
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  created() {
    this.projectRegister = ConstList.ROUTE_PROJECT_REGISTER;
    this.projectInfo = ConstList.ROUTE_PROJECT_INFO;
  },

  methods: {
    callList: function () {
      const params = new URLSearchParams();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/project", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then((response) => {
          this.project = response.data;
          if (this.project.length === 0) {
            this.errors.push(ConstList.EMPTY);
          } else {
            // プロジェクト一覧データを舐めてチェックボックスのチェック判定を行う。
            this.project.forEach((value) => {
              if (value.checked) {
                this.selectedPrjIds.push(value.id);
              }
            });
          }
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },

    openModal: function (item) {
      // 二重サブミット対策
      if (this.submit_flg) return;
      this.postItem = item;
      this.showModal = true;
    },
    // プロジェクトを削除
    deleteProject: function () {
      this.loading = true;
      this.project.forEach((value, i, array) => {
        if (this.postItem.id === array[i][ConstList.ID]) {
          this.project_id = this.postItem.id;
        }
      });
      // JSON形式のパラメータ
      const params = {
        id: this.project_id,
      };
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/projectDelete", params, {
          headers: {
            // content-type指定。@requestBodyでサーバ側にてバインドするため。
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          let count = "";
          count = response.data;
          if (count > 0) {
            alert("プロジェクトを設定中の方が" + count + "人います。");
            window.location.reload();
          } else {
            alert(ConstList.DELETE_MESSAGE);
            this.showModal = false;
            window.location.reload();
          }
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onToggle(item, nowChecked) {
      this.globalLoading = true;

      // 楽観的更新（失敗時に戻す用）
      const prev = item.checked;
      item.checked = nowChecked;

      const url = nowChecked
        ? `${process.env.VUE_APP_API_ORIGIN}/userProject/add`
        : `${process.env.VUE_APP_API_ORIGIN}/userProject/remove`;

      axios.post(url, { projectId: item.id }, { headers: { 'Content-Type': 'application/json' } })
        .then(() => {
          // ローカルカードを即時更新
          if (nowChecked) {
            if (!this.myProjects.some(p => p.id === item.id)) {
              this.myProjects = [{ id: item.id, name: item.name }, ...this.myProjects];
            }
          } else {
            this.myProjects = this.myProjects.filter(p => p.id !== item.id);
          }
          // サーバを正とする最終同期
          return axios.get(process.env.VUE_APP_API_ORIGIN + '/projects');
        })
        .then(res => {
          // 取得成功時のみサーバ値で確定
          if (res && res.data) this.myProjects = res.data;
        })
        .catch(err => {
          // 失敗したら見た目も戻す
          item.checked = prev;
          this.handleError(err);
        })
        .finally(() => {
          this.globalLoading = false;
        });
    },
    handleError(error) {
      axios.get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
        .then(() => alert(ConstList.SYSTEM_ERROR))
        .catch(() => alert(ConstList.SYSTEM_COMMUNICATION_ERROR));
    },
    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false;
    },
    // プロジェクト設定ボタン押下時イベント
    updateUserProject: function () {
      // 二重サブミット対策
      if (this.submit_flg) return;
      // 1件も選択されていない場合
      if (this.selectedPrjIds.length === 0) {
        alert("設定するプロジェクトを選択してください。");
        return;
      } else {
        //フラグがfalseならば、フラグをtrueにしたうえでsubmit
        this.loading = true;
        this.submit_flg = true;
        const currentPrjIds = [];
        this.project.forEach((obj) => {
          currentPrjIds.push(obj.id);
        });
        // JSON形式のパラメータ
        const params = {
          // 選択したプロジェクトID（複数）
          // ※昇順でソート。
          projectIds: this.selectedPrjIds.sort(),
          currentPrjIds: currentPrjIds,
        };
        axios
          .post(process.env.VUE_APP_API_ORIGIN + "/userProjectUpdate", params, {
            headers: {
              // content-type指定。@requestBodyでサーバ側にてバインドするため。
              "Content-Type": "application/json",
            },
          })
          .then(() => {
            this.submit_flg = false;
            alert(ConstList.REGISTER_MESSAGE);
            this.showModal = false;
            window.location.reload();
          })
          .catch((error) => {
            this.submit_flg = false;
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // ページ変更
    changePage: function (page) {
      this.selectedPrjIds = [];
      this.currentPage = page;
      this.callList();
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/projectCount")
        .then((response) => {
          const totalCount = response.data;
          this.totalPages = Math.ceil(totalCount / this.pageSize);
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
    // yyyy/mm/ddフォーマット変換
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
    fetchMyProjects() {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/projects")
        .then(res => { this.myProjects = res.data || []; })
        .catch(error => this.handleError(error));
    },
    goProject(id) {
      // 1) 今のページに該当行があれば既存ルートの渡し方に合わせる
      const row = this.project.find(x => x.id === id);
      if (row) {
        this.$router.push({ name: this.projectInfo, params: { value: row } });
        return;
      }
      // 2) 見つからない場合はIDだけ渡す（詳細側でID受け取りに対応していればOK）
      this.$router.push({ name: this.projectInfo, params: { projectId: id } });
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    this.callList();
    this.fetchTotalPages();
    this.fetchMyProjects();
  },
};
</script>

<style scoped>
th,
td {
  white-space: nowrap;
}
td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
